module.exports = __webpack_public_path__ + "static/media/Step2.58992ff3.svg";